import { render } from "solid-js/web";
import "@assets/css/index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "./App";
render(() => <App />, document.body);
if (process.env.NODE_ENV === "production") {
    serviceWorkerRegistration.register();
}
